<template>
  <div>
    <div class="title">Преобладающие породы по ярусам</div>
    <div class="layers">
      <div v-for="layer in layers">
        <div :key="layer">
          <div class="layer-title">{{ layer == 11 ? 'Единичные деревья':`Ярус ${layer} `}}</div>
          <div>
            <template v-for="unit in compositionUnits">
              <div
                v-if="unit.layer === layer"
                :key="unit.species_unit + unit.layer"
                class="layer-item"
              >
                <input
                  :id="
                    'composition-unit-' + unit.species_unit + '-' + unit.layer
                  "
                  type="radio"
                  :value="JSON.stringify(unit)"
                  :checked="unit.priority === '1'"
                  @change="handleChange"
                  :name="`primary-species-layer-${unit.layer}`"
                  :disabled="loading"
                />
                <label
                  :for="`composition-unit-${unit.species_unit}-${unit.layer}`"
                  >{{ unit.species_unit }}</label
                >
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processJson } from "@/api/general.api";
import {
  fetchCompositionUnits,
  fetchPrimarySpecies,
} from "./speciesPriority.api";

export default {
  data: () => ({
    picked: null,
    compositionUnits: [],
    primarySpecies: [],
    loading: false,
  }),

  computed: {
    layers() {
      const allLayers = this.compositionUnits.map((unit) => unit.layer);
      const result = new Set(allLayers);

      return result;
    },
  },

  created() {
    (async () => {
      const lpo_id = this.$store.state.selectedLpo.lpo?.lpo_id;
      this.compositionUnits = await fetchCompositionUnits(lpo_id);
      this.primarySpecies = await fetchPrimarySpecies(lpo_id);

      if (this.primarySpecies.length) {
        const finded = this.compositionUnits.find(
          (species) => species.species_id === this.primarySpecies[0].species_id
        );

        this.picked = finded ? JSON.stringify(finded) : null;
      }
    })();
  },

  methods: {
    async handleChange(event) {
      const lpo_id = this.$store.state.selectedLpo.lpo?.lpo_id;

      const value = JSON.parse(event.target.value);
      this.loading = true;
      await this.updatePriority(value);
      this.compositionUnits = await fetchCompositionUnits(lpo_id);
      this.primarySpecies = await fetchPrimarySpecies(lpo_id);
      this.loading = false;
    },

    updatePriority(newPriority) {
      const deleteSection = [];

      for (const species of this.primarySpecies) {
        if (species.layer !== newPriority.layer) {
          continue;
        }

        const temp = {
          tab_name: "data_lpo_species_priority",
          id: species.id,
        };
        deleteSection.push(temp);
      }

      const json_obj = [
        {
          i: {
            tab: [
              {
                tab_name: "data_lpo_species_priority",
                f_v: {
                  parent_id: this.$store.state.selectedLpo.lpo?.lpo_id,
                  layer: newPriority.layer,
                  species_id: newPriority.species_id,
                  gen: newPriority.gen,
                  priority: "1",
                },
              },
            ],
          },
        },
        {
          d: deleteSection,
        },
      ];

      const json_str = JSON.stringify(json_obj);
      return processJson(json_str);
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 0.2rem;
}
.layers {
  display: flex;
  gap: 8rem;
  align-items: flex-start;
}
.layer-title {
  font-weight: bold;
  color: #bbb;
  margin-bottom: 0.5rem;
}
.layer-item {
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
